import get from 'lodash/get';
import {
    SEND_REQUEST,
    requestSuccess,
    requestError,
    requestReceived,
    REFRESH_TOKEN
} from 'spark-state/common/request/reducer';
import { resourceNotFound, loader, gapPacketAccessDeniedAction, investigatorBrochureAccessDeniedAction } from 'spark-state/common/app/reducer';
import { alertMessage } from 'spark-state/common/messages/messagesReducer';

const requestMiddleware = (auth, http) => ({ dispatch }) => next => async action => {
    if (action.type === SEND_REQUEST) {
        const { request } = action;
        dispatch(loader(true));
        dispatch(requestReceived(request));

        await auth.refreshToken();

        return http
            .sendRequest(auth.getToken(), request)
            .then(response => {
                if (get(response, 'status') === 200 || get(response, 'status') === 201) {
                    dispatch(loader(false));
                    dispatch(requestSuccess(response));
                    return response;
                }else if(get(response, 'status') === 204 ) {
                    dispatch(loader(false));
                   return dispatch(resourceNotFound());
                } 
            })
            .catch(onRequestFail(dispatch, request));
    } else if (action.type === REFRESH_TOKEN) {
        await auth.refreshToken();
    }
    return next(action);
};

export default requestMiddleware;

const onRequestFail = (dispatch, request) => error => {
    if (error.response || error.request) {
        dispatch(requestError(error, request));
       if (get(error, 'response.status') === 502) {
            const message =
                get(error, 'response.data.message') || 'Uh oh! Service is unavailable now!';

            dispatch(alertMessage(message));
            window.location.reload(true);
        }else if (get(error, 'response.status') === 600) {
            return dispatch(gapPacketAccessDeniedAction());
        }else if (get(error, 'response.status') === 603) {
            return dispatch(investigatorBrochureAccessDeniedAction());
        }
        else {
            const message =
                get(error, 'response.data.message') ||
                'Uh oh! Something went wrong, please try again later or contact support';
            const messageType = request.url.includes('/recipient/zipFile');
            messageType ? dispatch(alertMessage(message, 'Recipient')) : dispatch(alertMessage(message));
        }
    } else {
        dispatch(alertMessage(error));
    }
    throw error;
};
